// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export class ExtEnrollmentCardInfoModel {
    'cardLastFourDigits'?: string;
    'expirationDate'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentCardInfoModel>> = [
        {
            "name":     "cardLastFourDigits",
            "baseName": "cardLastFourDigits",
            "type":     "string"
        },
        {
            "name":     "expirationDate",
            "baseName": "expirationDate",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentCardInfoModel.attributeTypeMap;
    }
}
